import {DropDownList} from "@progress/kendo-react-dropdowns";
import {filterBy} from "@progress/kendo-data-query";
import {useState} from "react";


const ListValue = props => {

    const listData = props.listData
    const dataID = props.dataID

    const textField = props.textField || "Name"
    const filterable = props.filterable || false

    // console.log("dropdown editor: ", props)

    // debugger

    // debugger

    const selectedValue=listData.find((c) => c.ID === dataID)
    const color = selectedValue ? selectedValue.Color : ""

    const colorStyle = (color !== undefined) ? "; background-color:" + color + "!important; " : ""


    return(
        <span
            style={{...props.style, backgroundColor:color }} // this applies styles that lock the column at a specific position
            className={props.className} // this adds classes needed for locked columns
        >

            {selectedValue ? selectedValue[textField] : ""}

        </span>
    )
}

export default ListValue